export default "__VITE_ASSET__B3$YTdMv__"